import { megabytesToBytes, bytesToKiloBytes } from '@vette/frontend-utils';

const MAX_FILE_SIZE = megabytesToBytes(20);
const ALLOWED_FORMATS = ['jpeg', 'jpg', 'png', 'gif', 'webp', 'heic', 'heif'];
export const supportedFormats = ALLOWED_FORMATS.join(', ').toUpperCase();

export const validate = async (acceptedFiles: File[]) => {
  if (acceptedFiles.length > 1) {
    return `Oops! It looks like you're trying to upload more than one image. Please select only one image file to upload.`;
  }

  const [file] = acceptedFiles;
  if (file.size > MAX_FILE_SIZE) {
    return `The uploaded file is too large (${Math.floor(
      bytesToKiloBytes(file.size)
    )}KB). The maximum file size is ${Math.floor(
      bytesToKiloBytes(MAX_FILE_SIZE)
    )}KB.`;
  }

  if (!ALLOWED_FORMATS.some(format => `image/${format}` === file.type)) {
    return `The uploaded file has an incorrect format. The supported formats are: ${supportedFormats}.`;
  }

  return;
};
